// extracted by mini-css-extract-plugin
module.exports = {"button":"CompareProductsSnackbar_button__l8dWg","fillBtn":"CompareProductsSnackbar_fillBtn__pOvrN","outlineBtn":"CompareProductsSnackbar_outlineBtn__I9C0n"};